import {CONSONANT_VOWEL_PAIRS_P} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_p";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_P_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_P} title="Consonant-Vowel Pairs: ㅍ (p)" />
     </>
);}